
import moment from 'moment';
import { getData, getTimestampData } from '@/components/report/service';
import {
  TransitDeliveryQuery,
  TransitDeliveryQueryDetails,
} from '../Sql';
import { SqlBase } from '../../../common';

const dateRange = [
  moment(new Date()).add(-14, 'days'),
  moment(new Date()).add(0, 'days')
]
export default {
  namespace: 'forecastCenterDepartBoardTransitDelivery',
  state: {
    // 下一站table
    page: 1, 
    nextData: [], 
    // 下一站省区table
    page2: 1,
    nextAreaData: [],

    dateRange: dateRange,
    modalVisible: false,
    modalType: '',
    modalTitle: '',
    dateType: undefined,
  },
  effects: {
    // 重置
    *setReset(_, { put }) {
      yield put({
        type: 'update',
        payload: {
          totalData: [],
          page: 1, 
          nextData: [], 
          page2: 1,
        },
      });
    },
    // 重置二级弹层
    *setResetModal(_, { put }) {
      yield put({
        type: 'update',
        payload: {
          dateRange: dateRange,
          modalVisible: false,
          dateType: undefined,
        },
      });
    },
    *getSelect(_, { put }) {
      yield put({ type: 'getNextSite' });
      yield put({ type: 'getNextArea' });
    },
    /**
     * 下一站明细
    */
    *getNextSite(_, { call, put, select }) {
      let centerFilter = yield select(({ forecastCenterDepartBoard }) => forecastCenterDepartBoard.searchParams.centerFilter);
      let query = yield select(({ forecastCenterDepartBoardModals }) => {
        return {
          dateType: forecastCenterDepartBoardModals.dateType,
          startDate: moment(forecastCenterDepartBoardModals.dateRange[0]),
          endDate: moment(forecastCenterDepartBoardModals.dateRange[1])
        }
      });
      const filter = TransitDeliveryQuery({
        startDate: query.startDate.format('YYYY-MM-DD 12:00:00'),
        endDate: query.endDate.format('YYYY-MM-DD 12:00:00'),
        scanSite: centerFilter,
      });
      const params = {
        aggregators: SqlBase()
      }
      const data = yield call(getData, { ...params, ...filter[0] });
      data && data.forEach((item, index) => {
        item.index = index;
      });
      yield put({
        type: 'update',
        payload: {
          nextData: data || []
        },
      });
    },
    /**
     * 下一省明细
    */
    *getNextArea(_, { call, put, select }) {
      let centerFilter = yield select(({ forecastCenterDepartBoard }) => forecastCenterDepartBoard.searchParams.centerFilter);
      let query = yield select(({ forecastCenterDepartBoardModals }) => {
        return {
          dateType: forecastCenterDepartBoardModals.dateType,
          startDate: moment(forecastCenterDepartBoardModals.dateRange[0]),
          endDate: moment(forecastCenterDepartBoardModals.dateRange[1])
        }
      });
      const filter = TransitDeliveryQuery({
        startDate: query.startDate.format('YYYY-MM-DD 12:00:00'),
        endDate: query.endDate.format('YYYY-MM-DD 12:00:00'),
        scanSite: centerFilter,
      });
      const params = {
        aggregators: SqlBase()
      }
      const data = yield call(getData, { ...params, ...filter[1] });
      data && data.forEach((item, index) => {
        item.index = index;
      });
      yield put({
        type: 'update',
        payload: {
          nextAreaData: data || []
        },
      });
    },
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
  },
}